export default __webpack_public_path__ + "static/media/news174.485dffa5.jpg";